export const LAB_ALLOWED_PROD_USER_IDS = [
  'cf01cdf4-1019-4641-bf97-843fcd8fae15', // William Ritossa
  '28ede005-db57-4f99-b85c-6b635b7620c6', // Geo
  'cb6bfdbf-3bad-403a-a24a-7782678402e4', // Harry Nguyen
  '8eb032a9-bd00-431f-b28c-9165aeada95e', // Muen
  'd677d037-18de-4603-9026-acd4e7f506c0', // William Feng
  '5ebc0a7f-6511-4b4f-86e0-e346c7c94750', // Chris Lee
  '945dd4c1-3c4f-40d0-8314-fddd0e4e3d51', // Shay
  'b4442932-9f78-48d5-86bf-c0d9442f67ca', // Shay Hamama
  '54948b8f-b6b3-46c6-9da1-b84294cae4a5', // Fabien
  '0386d4bc-43f1-4f1a-ada0-c667c3dbffe4', // Sam Drown
  '69fbdc21-93a5-47e3-b3c6-2355d47e363b', // Joss
  '30c95693-418a-45fa-b79b-f8ea5556b616', // Kostya
  '9c901c03-71b3-4033-af4d-dcfc59237bc2', // Tom S
  'a86d01ed-c9e9-4df0-8378-9d35e8e7c7a1', // Jake G
  '84da38e8-2f41-4223-8ccd-c3df7b19a2cb', // James Nevett
  'e3c17c15-59f7-4258-bf28-4e6841dbd544', // GusPlus
  '81d2936a-4b29-4fd2-8875-7569205d5cea', // Braydn
  '53c855cf-f113-4715-bf95-8bec31e28545', // Adi
  '92dd8778-c05f-491e-8a00-d00eed01ec5b', // Quan
  '5b5d9fc6-d043-4dae-8401-1b6840cf84de', // Finbar
  '8681d719-b5ee-49e4-bc24-e457fef5c33f', // Nick Griffith
  '4a902447-0ab8-4c5c-aa6f-7135da31423a', // Lewis Bandas
  '2b525cef-a9e1-49e5-9575-fa0639f2339c', // Ming
  'd593a2ad-12d8-4096-b9d9-1df25797448a', // Harry Frankel
] as const;

const allowedProdUserIds = new Set(LAB_ALLOWED_PROD_USER_IDS.map((id) => id.toLowerCase()));

export function canAccessLabV2(user: { id_member?: string | null } | null | undefined): boolean {
  if (!user?.id_member) {
    return false;
  }

  if (window.configs?.APP_ENV !== 'production') {
    return true;
  }

  return allowedProdUserIds.has(user.id_member.toLowerCase());
}
